module.exports = {"insufficient_coins":"Not enough coins.","error":"Error processing order.","ordered":"Product ordered."};